import React, {Component} from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import styles from './styles.module.css';
import { AskQuoteApi } from '../../api/askQuote';

class AskQuote extends Component {
    state = {
        name: '', 
        contact: '',
        message: '',
        errors: {},
        showCaptcha: false,
    };

    _handleChangeName = ({target:{value}}) => this.setState({name: value});
    _handleChangeContact = ({target:{value}}) => this.setState({contact: value});
    _handleChangeMessage = ({target:{value}}) => this.setState({message: value});

    _handleSendMessage = () =>{
        const errors = this.validateMessage();

        if(Object.keys(errors).length == 0){
            this.setState({showCaptcha: true})
        }
    }
    
    _handleCaptcha = () => {
        const {name, contact, message} = this.state;
        const api = new AskQuoteApi();

        api.sendMessage({name, contact, message}).then(({data}) => {
            this.setState({
                name: '',
                contact: '',
                message: '',
                showCaptcha: false,
                messageSent: true,
            })
        }).catch(err => {
            console.error(err);
            alert('Ocorreu um problema ao submeter o seu pedido de contacto. \n\rPor favor entre em contacto através de contacto telefónico ou email.\n\r Obrigado')
        })
    }

    validateMessage = () => {
        const {name, contact, message} = this.state;
        let errors = {};

        if(!name || name.trim() == ''){
            errors.name = 'Campo Obrigatório'
        }

        if(!contact || contact.trim() == ''){
            errors.contact = 'Campo Obrigatório'
        }

        if(!message || message.trim() == ''){
            errors.message = 'Campo Obrigatório'
        }

        this.setState({errors});

        return errors;
    }

    render = () => (
        <div className={styles.main}>
            <div className={styles.title}>
                {'Pedir Orçamento'}
            </div>
            <div className={styles.subtitle}>
                <div>
                    {'Gostava pedir orçamento ou saber mais sobre este serviço?'}
                </div>
                <div>
                    {'Envie-nos uma mensagem e entraremos em contacto!'}
                </div>
            </div> 
            <form>
                <input 
                    className={this.state.errors.name && styles.inputWithError}
                    type="text"
                    value={this.state.name}
                    onChange={this._handleChangeName}
                    placeholder={'Insira o seu nome'}/>
                
                <input 
                    className={this.state.errors.contact && styles.inputWithError}
                    type="text"
                    value={this.state.contact}
                    onChange={this._handleChangeContact}
                    placeholder={'Insira o seu telefone/email'}/>
                
                <textarea 
                    className={this.state.errors.message && styles.inputWithError}
                    value={this.state.message}
                    onChange={this._handleChangeMessage}
                    placeholder={'Insira a sua mensagem'}/>
                
                <div className={styles.formSubmit}>
                    

                    {
                        this.state.showCaptcha ? (
                            <ReCAPTCHA
                                sitekey={'6LcGv5wUAAAAAPayPE-Gs6dk35lpj1M86Mv_YubS'}
                                onChange={this._handleCaptcha}/>
                        ) : (
                        <button 
                            type="button" 
                            onClick={this._handleSendMessage}>
                            {'Enviar Mensagem'}
                        </button>
                        )
                    }

                    {
                        this.state.messageSent ? (
                            <div className={styles.successMessage}>
                                <p>
                                    {'Mensagem Enviada'}
                                </p>
                                <p>
                                    {'Agradecemos o seu contacto!'}
                                </p>
                            </div>
                        ) : null
                    }
                </div>
            </form>
        </div>
    );
};

export default AskQuote;